webpackJsonp([219425921280941],{

/***/ 456:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Connect = __webpack_require__(29);
	
	var _Connect2 = _interopRequireDefault(_Connect);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Connect2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'singleton'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This blueprint is useful when you know there will only ever be a single resource returned by an API endpoint. While rare, this exists in endpoints like ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '/user'
	      ),
	      ' or ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '/profile'
	      ),
	      ' that return an object that describes the current user.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Usage'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Example usage is below:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import { connect } from \'lore-hook-connect\';\n\n      connect((getState, props) => {\n        return {\n          tweet: getState(\'currentUser\')\n        };\n      })\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'When invoked, this blueprint will look in the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'currentUser'
	      ),
	      ' reducer, and return whatever it finds. If nothing exists, it will invoke the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'currentUser'
	      ),
	      ' action.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This blueprint does not accept any paramters, because it assumes there will only ever be a single resource provided. So it\'s "give me THE resource", and not "give me a resource WHERE some condition is true".'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Blueprint'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      export default {\n\n        getPayload: function(reducerState, params) {\n          return reducerState;\n        },\n\n        callAction: function(action, params) {\n          return action().payload;\n        }\n\n      };\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-connect-singleton-js-7a2777d8b6953da0b082.js